module.exports = "pegasus/assets/social_follow_library_block.png";